module.exports = __webpack_public_path__ + "static/media/Melissa.61216f71.png";